import Vue from 'vue';
import VueRouter from 'vue-router';
// sign in
import SignIn from '../views/SignIn.vue';

// other pages
import RealTimeStatus from '../views/RealTimeStatus.vue';
import Panic from '../views/Panic.vue';
import InOutBoard from '../views/InOutBoard.vue';
import Attendance from '../views/Attendance.vue';
import ContactTracing from '../views/ContactTracing.vue';
import ReportOutdoorLoc from '../views/ReportOutdoorLoc.vue';
import ZoneControl from '../views/ZoneControl.vue';
import WatchAssignment from '../views/WatchAssignment.vue';
import HardwareManagement from '../views/HardwareManagement';
import Feedback from '../views/Feedback.vue';


// firebase
import firebase from '../firebase.js';

Vue.use(VueRouter);

const routes = [{
        path: '/',
        name: 'SignIn',
        component: SignIn,
        beforeEnter: (to, from, next) => {
            let user = firebase.auth().currentUser;

            if (user) {

                next({
                    name: "RealTimeStatus"
                });
            } else {
                next();
            }
        }
    },
    {
        path: '/realtimestatus',
        name: 'RealTimeStatus',
        component: RealTimeStatus,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/panic',
        name: 'Panic',
        component: Panic,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/inoutboard',
        name: 'InOutBoard',
        component: InOutBoard,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/attendance',
        name: 'Attendance',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: Attendance,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/contacttracing',
        name: 'ContactTracing',
        component: ContactTracing,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/reportoutdoorloc',
        name: 'ReportOutdoorLoc',
        component: ReportOutdoorLoc,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/zonecontrol',
        name: 'ZoneControl',
        component: ZoneControl,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/watchassignment',
        name: 'WatchAssignment',
        component: WatchAssignment,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/hardwaremanagement',
        name: 'HardwareManagement',
        component: HardwareManagement,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/feedback',
        name: 'Feedback',
        component: Feedback,
        meta: {
            requiresAuth: true
        }
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(rec => rec.meta.requiresAuth)) {
        let user = firebase.auth().currentUser;
        console.log(user);
        if (user) {
            next();
        } else {
            next({
                name: "SignIn"
            });
        }
    } else {
        next();
    }
});

export default router;